export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./navigation-button.vue?vue&type=template&id=1805ce50&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./skins/xkiosk/components/button/africa/navigation-button.vue?vue&type=template&id=1805ce50&scoped=true
// module id = xjOL
// module chunks = 37